﻿export interface ICenterMetrics {
    preselectsReviewed: number;
    totalMatches: number;
    averagePercentReviewedThisMonth: number;
    percentOfTitersIdentified: number;
    declineRatio: number;
    pendingMatches: number;
    percentOfDonorsSubTyped: number;
}
